import { Box, Chip, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import { searchResultMap } from './searchResultsMap';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const SearchCategoryFilter = ({
  selectedCategories,
  onCategoryChange,
  availableIndexes,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const handleToggle = (categoryKey) => {
    const newSelection = selectedCategories.includes(categoryKey)
      ? selectedCategories.filter((c) => c !== categoryKey)
      : [...selectedCategories, categoryKey];
    onCategoryChange(newSelection);
  };

  // Nur Kategorien anzeigen, die in availableIndexes enthalten sind
  // Sortiert nach Priorität
  const visibleCategories = useMemo(() => {
    return Object.entries(searchResultMap)
      .filter(([key]) => availableIndexes?.some((idx) => idx.includes(key)))
      .sort(([, a], [, b]) => (a.priority || 3) - (b.priority || 3));
  }, [availableIndexes]);

  return (
    <Box className="flex flex-wrap gap-2">
      {visibleCategories.map(([key, config]) => {
        const Icon = config.Icon;
        const isActive = selectedCategories.includes(key);

        return (
          <Chip
            key={key}
            icon={
              <Icon
                sx={{
                  fontSize: 14,
                  color: isActive ? colors.info : colors.grey[500],
                }}
              />
            }
            label={t(config.label)}
            onClick={() => handleToggle(key)}
            size="small"
            variant="outlined"
            sx={{
              px: '8px',
              bgcolor: isActive ? colors.info + '30' : 'transparent',
              borderColor: isActive ? colors.info + '80' : colors.grey[600],
              opacity: selectedCategories.length === 0 || isActive ? 1 : 0.5,
              '&:hover': {
                bgcolor: colors.info + '20',
                borderColor: colors.info + '60',
                opacity: 1,
              },
            }}
          />
        );
      })}
    </Box>
  );
};
